/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const updateTenantStatusDtoSchema = z.object({
    "optIn": z.optional(z.boolean().describe("Set tenant opt-in timestamp to server now")),
"optOut": z.optional(z.boolean().describe("Set tenant opt-out timestamp to server now"))
    })